import React from "react";
import "./Services.css";
import Nav from "../Nav";
import { Link,withRouter} from "react-router-dom";


class Services extends React.Component {
    render() {
        return (
            <div>
                <Nav/>
                <div className="row jumbotron">
          <div className="col-4 jumbotron" style={{height: '150vh'}}>
            <div className="container">
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/ProS">01 Products</a></p>
              <hr style={{backgroundColor: 'black', width: '100%'}}/>
              <p className="ab"><a style={{color: 'black', textDecoration: 'none'}} href="/Services"> 02 Services</a></p>
              <hr style={{backgroundColor: 'black',width: '100%' }}/>
            </div>
          </div>
        <div className="col-8">
        <div class="abhead16">
        <p></p>
        </div>
        <div class="jumbotron">
          <p style={{margin: 0, fontWeight: 'bold', fontSize: '30px'}}>OUR SERVICES</p>
          <hr style={{margin: 0, backgroundColor: 'green'}} className="w-100"/>
          <p style={{ fontWeight: 'bold'}}>Affordable Eco-Homes, Real Estate Communities; Eco-Cities Development and Leasing of Serviced Plots/Land</p>
            <ul>
                <li>•  Individual homes construction with our innovative construction materials and technologies;</li>
                <li>•  Estate community construction with our innovative construction materials and technologies;</li>
                <li>•  Eco-City construction with our innovative construction materials and technologies; </li>
            </ul>
            <p className="text-justify mt-5">GOOD MORNING BAMBOO ECO-CITY provides fully tailored solutions for the needs of Ghanaian and International companies, with world-class infrastructure. The Eco-city is designed to accommodate a range of uses including residential, manufacturing, processing, storage, logistics and service companies. THE GOOD MORNING BAMBOO ECO-CITY is the idea place for individuals/families and companies requiring a modern-day, high quality residential accommodation, business area for operations, growth and success.<br/><br/>
           <span style={{fontWeight: 'bold'}}> Over 200-Acre of serviced land immediately available on a specially designed site.</span>
<br/><span style={{fontWeight: 'bold'}}>Electricity:</span> Fully renewable energy supply to the Eco-City at 50% less tariff compare to the conventional electricity supply.
<span style={{fontWeight: 'bold'}}><br/>Roads:</span> Sustainable road constructed with our innovative construction materials and technologies.
<span style={{fontWeight: 'bold'}}><br/>Water and Waste Water:</span> Sustainable water supply and Waste Water resources management system dedicated to supply sustainable water and manage sustainable waste water resources at the Eco-City at 50% less cost compare to the conventional method.
<span style={{fontWeight: 'bold'}}><br/>Security and Safety:</span> First-class integrated safety and high-tech security systems.
<span style={{fontWeight: 'bold'}}><br/>Electronics, Infocomm, AI, Robotics & Nanotechnology:</span> State-of-the-art Infocomm, etc., networking with provision for ultra-fast internet services.
            </p>

</div>
</div>
</div>
            </div>
        )
    }
}
export default withRouter(Services);